import { IonIcon, useIonModal } from "@ionic/react";
import { useEffect } from "react";
import styles from "./DeviceTransitPolicyTile.module.css";
import { addOutline } from "ionicons/icons";
import AddDoorPolicyModal from "../modals/AddDoorPolicyModal";
import { useCommonTranslation } from "../hooks/useTranslation";

interface Props {
    deviceId: string;
}

const DeviceTransitPolicyAddButton: React.FC<Props> = ({ deviceId }) => {
    const [presentAddModal, dismissAddModal] = useIonModal(AddDoorPolicyModal, {
        deviceId,
        dismiss: (data: string, role: string) => dismissAddModal(data, role)
    });
    const { t: tCommon } = useCommonTranslation();

    // Screenshot builds only: ?addDoorPolicy on the device page deep-links
    // into the Add Door Policy modal for the capture harness. Dead code in
    // production builds.
    useEffect(() => {
        if (import.meta.env.MODE !== 'screenshot') {
            return;
        }
        if (new URLSearchParams(window.location.search).has('addDoorPolicy')) {
            presentAddModal({
                presentingElement: document.getElementsByTagName('ion-router-outlet')[0]
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <button className={`${styles.tile} ${styles.add}`} onClick={() => presentAddModal({
            presentingElement: document.getElementsByTagName('ion-router-outlet')[0]
        })}>
            <IonIcon icon={addOutline} />
            <label>{tCommon('buttons.add')}</label>
        </button>
    );
};

export default DeviceTransitPolicyAddButton;
